import { createContext, useContext, useState, useCallback } from 'react'

interface LayoutWideCtx {
  wide: boolean
  setWide: (v: boolean) => void
}

export const LayoutWideContext = createContext<LayoutWideCtx>({ wide: false, setWide: () => {} })

export function useLayoutWideState() {
  const [wide, setWideRaw] = useState(false)
  const setWide = useCallback((v: boolean) => setWideRaw(v), [])
  return { wide, setWide }
}

export function useLayoutWide() {
  return useContext(LayoutWideContext)
}
